
const Dashboard = () => {
  return (
    <div className="p-[30px]">
        <h1 className="text-2xl font-[700]">Dashboard Page</h1>
    </div>
  )
};

export default Dashboard;
